import {Component, OnInit} from "@angular/core";
import {JwtService} from "../../_core/lib/jwt.service";
import {UserCompanySettings} from "../../_core/classes/user-company-settings";
import {
  CtBinaryOperator,
  CtCardConfiguration,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelService,
  CtNoteWidgetConfiguration,
  CtNoteWidgetServerSideConfiguration,
  FormatConfigService
} from "@ctsolution/ct-framework";
import {
  ENTRY_HANDLING_CARD,
  IMPORT_DATA_CARD, ITEM_CREATE_CARD, ITEM_LIST_CARD, LEAD_COMPLETE_CARD, LEAD_PROSPECT_CARD, MODULE_CREATE_CARD,
  NEW_MOVEMENT_CARD,
  NEW_ORDER_CARD, TRANSIT_HANDLING
} from "./dashboard.warehouse-widget";
import {Router, UrlTree} from "@angular/router";
import {RoleService} from "../../_core/lib/role.service";
import {NEW_REGISTER_CARD, REGISTER_CARD, WORK_ORDER_CARD} from "./dashboard.monitoring-widget";
import {
  UserWorkingHoursWizardService
} from "../../components/user-working-hours/user-working-hours-wizard/user-working-hours-wizard.service";
import {HandlingStateEnum} from "../../_core/enum/handling-state.enum";
import {NotesService} from "../../_core/lib/notes.service";
import {CtWidgetNote} from "@ctsolution/ct-framework";
import {HandlingRouteData} from "../../_core/route-data/handling.route-data";
import {Handling} from "../../_core/classes/handling";
import {CtManagerService} from "../../_core/lib/ct-manager.service";
import { LeadRouteData } from "../../_core/route-data/lead.route-data";
import { CompanyType } from "../../_core/enum/company-type";
import { DashboardLeadHelper } from "./helper/dashboard-lead.helper";
import { CONTACT_CARD_PRIVATE, CONTACT_CARD_BUSINESS_CREATE, DashboardCustomerHelper } from "./helper/dashboard-customer.helper";
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { DashboardOrderHelper } from "./helper/dashboard-order.helper";
import { DashboardWorkOrderHelper } from "./helper/dashboard-workorder.helper";
import { DashboardTaskHelper } from "./helper/dashboard-task.helper";
import { LeadStatusEnum } from "../../_core/enum/lead-status.enum";


@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styles: [
    `::ng-deep .dashboard-container {
      h3 {
        font-size: 18px;
        font-weight: 500;
      }

      .ct-card-container .mat-card-content {
        padding: 10px 20px;
      }
    }`
  ]
})
export class DashboardComponent implements OnInit {

  cardList: CtCardConfiguration[] = [];
  counterList: CtCardConfiguration[] = [];
  masterCardList: CtCardConfiguration[] = [];
  masterCardList2: CtCardConfiguration[] = [];

  companySettings: UserCompanySettings | null = null;
  viewModel = {
    userHasMonitoringManagementEnabled: false,
    userHasWarehouseManagementEnabled: false,
    CRM: false
  }
  isAdministrator: boolean | null = null;

  noteConfiguration: CtNoteWidgetConfiguration = CtNoteWidgetConfiguration
    .create()
    .setServerSideConfiguration(
      CtNoteWidgetServerSideConfiguration
        .create()
        .setAssigner((value: CtWidgetNote) => this.notesService.notePut(value))
        .setGetter(() => this.notesService.getList())
        .setDeleter((value: CtWidgetNote) => this.notesService.noteDelete(value)));

  constructor(
    private jwt: JwtService,
    private router: Router,
    private roleService: RoleService,
    private notesService: NotesService,
    private modelService: CtModelService<any>,
    private userworkinghoursWizardService: UserWorkingHoursWizardService,
    private managerService: CtManagerService,
    private leadHelper : DashboardLeadHelper,
    private orderHelper : DashboardOrderHelper,
    private customerHelper : DashboardCustomerHelper,
    private workorderHelper : DashboardWorkOrderHelper,
    private formatConfigService : FormatConfigService,
    private dashboardTaskHelper: DashboardTaskHelper,
) {
  }

  ngOnInit() {

    this.setup();

  }

  get masterWidgetEnabled(): boolean {

    return this.userWorkingHoursWizardEnabled || this.notesWidgetEnabled;

  }

  get notesWidgetEnabled(): boolean {

    return (this.companySettings?.UserHasNotesEnabled ?? false) && (this.isAdministrator ?? false);

  }

  get userWorkingHoursWizardEnabled(): boolean {

    return (this.viewModel.userHasMonitoringManagementEnabled ?? false) && !(this.isAdministrator ?? false);

  }

  async setup() {


    const formatConfiguration: CTConfigurationModel = CTConfigurationModel.create();

    await this.managerService.getComponentOverride("formatDigits", "formatConfiguration", formatConfiguration).then((component) => {
      return;
    });

    this.formatConfigService.setDefaultPriceDigits(formatConfiguration.formatPrice);
    this.formatConfigService.setDefaultNumberDigits(formatConfiguration.formatNumber);
    this.companySettings = await this.jwt.getUserCompanySettings();
    this.isAdministrator = await this.roleService.is.administrator();

    this.viewModel.userHasWarehouseManagementEnabled = await this.managerService.hasEnabled.warehouse() ?? false;
    this.viewModel.userHasMonitoringManagementEnabled = await this.managerService.hasEnabled.monitoring() ?? false;
    this.viewModel.CRM = await this.managerService.hasEnabled.CRM() ?? false;

     if(this.viewModel.CRM){

       this.leadHelper.getLeadWidgets(this.cardList);
       this.getLeadBusinessProspectsCounter().then();
       this.getLeadBusinessCompleteCounter().then();

     }


    if (this.viewModel.userHasWarehouseManagementEnabled) {

      const handlingManagementDisabled = this.companySettings?.HandlingManagementDisabled;

      const handlingMovementsConfiguration : CTConfigurationModel = CTConfigurationModel.create()

      await this.managerService.getComponentOverride("dashboard", "handlingMovementsConfiguration", handlingMovementsConfiguration).then((component) => {
        return;
      });


      if (!handlingManagementDisabled && handlingMovementsConfiguration.visible) {

        this.getMovementsInPreparation().then();
        this.getMovementsInTransit().then();
        this.orderHelper.getOrderCounter(this.counterList);

      }

      this.orderHelper.getOrderCardList(this.counterList,this.masterCardList);

      this.managerService.getComponentOverride("dashboard", "new_order", NEW_ORDER_CARD).then((component) => {
        return;
      });

      const masterCardList = [NEW_ORDER_CARD.setAction(() => this.router.navigate(["/", "handling", "order", "create"]))];

      if (!handlingManagementDisabled) {

        masterCardList.push(NEW_MOVEMENT_CARD.setAction(() => this.router.navigate(["/", "handling", "movement", "create"])))

        await this.managerService.getComponentOverride("dashboard", "warehouse_handling_movement", NEW_MOVEMENT_CARD).then((component) => {
          return;
        });

      }

      this.masterCardList2 = [
        IMPORT_DATA_CARD.setAction(() => this.router.navigate(["/", "ct-model", "item-import"]))
      ];

      await this.managerService.getComponentOverride("dashboard", "warehouse_import_item", IMPORT_DATA_CARD).then((component) => {
        return;
      });

      this.managerService.getComponentOverride("dashboard", "item_list", ITEM_LIST_CARD).then((component) => {
        return;
      });

      const cardList = [
        ITEM_LIST_CARD.setAction(() => this.router.navigate(["/", "catalog", "item"])),
        ITEM_CREATE_CARD.setAction(() => this.router.navigate(["/", "catalog", "item", "create"]))
      ];

      if (!handlingManagementDisabled) {

        cardList.push(MODULE_CREATE_CARD.setAction(() => this.router.navigate(["/", "catalog", "module", "create"])))

        await this.managerService.getComponentOverride("dashboard", "warehouse_module_create", MODULE_CREATE_CARD).then((component) => {
          return;
        });
      }

      this.masterCardList.push(...masterCardList);
      this.cardList.push(...cardList);

    }

    if (this.viewModel.userHasMonitoringManagementEnabled && this.isAdministrator) {

      this.masterCardList
        .push(NEW_REGISTER_CARD.setAction(() => this.userworkinghoursWizardService.open()));

      this.cardList.push(
        REGISTER_CARD.setAction(() => this.router.navigate(["/", "user-working-hours"])),
        WORK_ORDER_CARD.setAction(() => this.router.navigate(["/", "work-order"])));

    }

    if (this.isAdministrator) {

      this.customerHelper.getCustomerWidgets(this.cardList);

    }

    this.workorderHelper.getWorkOrderWidgets(this.cardList, this.counterList, this.masterCardList);

    this.dashboardTaskHelper.getTaskWidgets(this.counterList);

  }

  async getMovementsInTransit() {

    const result = await this.getMovementsByState(HandlingStateEnum.OnTheWay);
    this.setupCounter(TRANSIT_HANDLING, result);

  }

  async getMovementsInPreparation() {

    const result = await this.getMovementsByState(HandlingStateEnum.Draft);
    this.setupCounter(ENTRY_HANDLING_CARD, result);

  }

  async getLeadBusinessProspectsCounter() {

    this.managerService.getComponentOverride("dashboard", "lead_counter_prospect", LEAD_PROSPECT_CARD).then((component) => {
      return;
    });

    const resultProspect = await this.getLeadByFilter(LeadStatusEnum.IN_GESTIONE);

        const queryObject = {
          constants: [
            {
              Field: "[CustomerType.Type] is not null AND [CustomerType.Type] = ?",
              OperatorType: CtBinaryOperator.OrOperator,
              Value: [CompanyType.Business]
            },
            {
              Field: "[Customer.Type.Type] is not null AND [Customer.Type.Type] = ?",
              OperatorType: CtBinaryOperator.OrOperator,
              Value: [CompanyType.Business]
            },
            {
              Field: "LeadStatus.Type",
              OperatorType: CtBinaryOperator.InOperator,
              Value: [LeadStatusEnum.IN_GESTIONE]
            }
          ]
        };

        const queryString = JSON.stringify(queryObject);
        const urlTree: UrlTree = this.router.createUrlTree(['/lead/list'], { queryParams: { q: queryString } });

        // Convertiamo l'UrlTree in una stringa e apriamo una nuova scheda
        const fullUrl = this.router.serializeUrl(urlTree);

        LEAD_PROSPECT_CARD.setAction(() => window.open(fullUrl, '_blank'));

    this.setupCounter(LEAD_PROSPECT_CARD, resultProspect);

  }

  async getLeadBusinessCompleteCounter() {


    this.managerService.getComponentOverride("dashboard", "lead_counter_complete", LEAD_COMPLETE_CARD).then((component) => {
      return;
    });

    const resultComplete = await this.getLeadByFilter(LeadStatusEnum.COMPLETATO);

        const queryObject = {
          constants: [
            {
              Field: "[CustomerType.Type] is not null AND [CustomerType.Type] = ?",
              OperatorType: CtBinaryOperator.OrOperator,
              Value: [CompanyType.Business]
            },
            {
              Field: "[Customer.Type.Type] is not null AND [Customer.Type.Type] = ?",
              OperatorType: CtBinaryOperator.OrOperator,
              Value: [CompanyType.Business]
            },
            {
              Field: "LeadStatus.Type",
              OperatorType: CtBinaryOperator.InOperator,
              Value: [LeadStatusEnum.COMPLETATO]
            }
          ]
        };

        const queryString = JSON.stringify(queryObject);
        const urlTree: UrlTree = this.router.createUrlTree(['/lead/list'], { queryParams: { q: queryString } });

        // Convertiamo l'UrlTree in una stringa e apriamo una nuova scheda
        const fullUrl = this.router.serializeUrl(urlTree);

        LEAD_COMPLETE_CARD.setAction(() => window.open(fullUrl, '_blank'));

    this.setupCounter(LEAD_COMPLETE_CARD, resultComplete);

  }

  private setupCounter(counter: CtCardConfiguration, result: CtModelConfiguration<any>) {

    counter
      .setDescription((result?.TotalElement ?? 0) > 0 ? result.TotalElement : "0"); // temporaneo, per mostrare 0 nel pannello

    this.counterList
      .push(counter);

  }

  private getMovementsByState(state: HandlingStateEnum) {

    const configuration: CtModelConfiguration<any> = CtModelConfiguration
      .create()
      .setRouteData(HandlingRouteData());

    const operators: CtModelDatatableOperators = CtModelDatatableOperators
      .create()
      .setFilters([
        CTModelDatatableFilter
          .create()
          .setField("HandlingState")
          .setValue(state)
          .setOperatorType(CtBinaryOperator.Equal)
      ]);

    return new Promise<CtModelConfiguration<Array<Handling>>>(resolve => {

      this.modelService
        .getList(configuration, operators)
        .subscribe(response => resolve(response.Result))

    })

  }

  private getLeadByFilter(state: LeadStatusEnum) {

    const configuration: CtModelConfiguration<any> = CtModelConfiguration
      .create()
      .setRouteData(LeadRouteData());

    const operators: CtModelDatatableOperators = CtModelDatatableOperators
      .create()
      .setFilters([
        CTModelDatatableFilter
          .create()
          .setField("LeadStatus.Type")
          .setValue([state])
          .setOperatorType(CtBinaryOperator.InOperator),

          CTModelDatatableFilter
          .create()
          .setField("[CustomerType.Type] is not null AND [CustomerType.Type] = ?")
          .setValue([CompanyType.Business])
          .setOperatorType(CtBinaryOperator.OrOperator),

          CTModelDatatableFilter
          .create()
          .setField("[Customer.Type.Type] is not null AND [Customer.Type.Type] = ?")
          .setValue([CompanyType.Business])
          .setOperatorType(CtBinaryOperator.OrOperator),
      ]);

    return new Promise<CtModelConfiguration<Array<any>>>(resolve => {

      this.modelService
        .getList(configuration, operators)
        .subscribe(response => resolve(response.Result))

    })

  }

}
